import React from 'react';
import PropTypes from 'prop-types';

import './FooterLinks.scss';

const FooterLinks = props => (
  <nav className="LinksNav">
    {props.links.items.map((item) =>
      (<li key={item.linkUrl}>
        <a
          href={item.linkUrl}
          className="LinksNav__link"
          target="_blank">
          <span className="LinksNav__link-text">
            {item.linkText}
          </span>
        </a>
      </li>)
    )}
  </nav>
);

FooterLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default FooterLinks;
